import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexProfilesRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/admin/profiles', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const createProfileRequest = ({ dispatch, params, formData, failureCallback, successCallback }) => {
  ApiService.request('post', '/admin/profiles', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const showProfileRequest = (id, { dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', `/admin/profiles/${id}`, {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const updateProfileRequest = (id, { dispatch, params, formData, failureCallback, successCallback }) =>
  ApiService.request('put', `/admin/profiles/${id}`, {
    dispatch,
    params,
    formData,
    successCallback,
    failureCallback
  });

export const deleteProfileRequest = (id, { dispatch, failureCallback, successCallback }) =>
  ApiService.request('delete', `/admin/profiles/${id}`, {
    dispatch,
    failureCallback,
    successCallback
  });

export const debounceIndexProfilesRequest = AwesomeDebouncePromise(indexProfilesRequest, 300);
